// extracted by mini-css-extract-plugin
export default {"text":"Text-module--text--3H-b4"};